import Availability from "app/models/availability"

export enum Types {
  GET = "TEMPLATE_WEEK_AVAILABILITIES_GET",
  GET_SUCCESS = "TEMPLATE_WEEK_AVAILABILITIES_GET_SUCCESS",
  GET_FAIL = "TEMPLATE_WEEK_AVAILABILITIES_GET_FAIL",
}

export type Action = GetWeekAvailabilitiesAction | GetWeekAvailabilitiesSuccessAction | GetWeekAvailabilitiesFailAction

export type GetWeekAvailabilitiesAction = {
  payload: {
    templateId: string
    sort?: string[]
  }
  type: Types.GET
}

export type GetWeekAvailabilitiesSuccessAction = {
  type: Types.GET_SUCCESS
  payload: { data: Availability[] | undefined }
}

export type GetWeekAvailabilitiesFailAction = {
  type: Types.GET_FAIL
  payload: { errors: object }
}

export function getWeekAvailabilities(payload: { templateId: string; sort?: string[] }): GetWeekAvailabilitiesAction {
  return {
    payload,
    type: Types.GET,
  }
}

export function getWeekAvailabilitiesSuccess(data: Availability[]): GetWeekAvailabilitiesSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}
export function getWeekAvailabilitiesFail(errors: object): GetWeekAvailabilitiesFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}
